export enum ResourceQueryKeys {
  GetResource = 'GetResource',
  GetResourcesList = 'GetResourcesList',
  GetOpeningHOurs = 'GetOpeningHOurs',
  GetResourceOptions = 'GetResourceOptions',
  GetResourceGroups = 'GetResourceGroups',
  GetTimeline = 'GetTimeline',
  GetResourceStatus = 'GetResourceStatus',
  GetResourceTags = 'GetResourceTags',
  GetResourceOverview = 'GetResourceOverview',
  GetSuggestedResources = 'GetSuggestedResources',
}
